<form
  *transloco="let t"
  [formGroup]="dataService.formGroupSettings"
  class="mt-10 flex max-w-96 flex-col gap-y-2"
  role="form"
>
  <app-input-field
    [control]="dataService.formGroupSettings.controls.learningPlanName"
    [label]="
      t('portal.trainings.builder.stepper.settings.form.trainingName.label')
    "
    [placeholder]="
      t(
        'portal.trainings.builder.stepper.settings.form.trainingName.placeholder'
      )
    "
  />
  <app-select
    [control]="dataService.formGroupSettings.controls.topicAreaId"
    [label]="
      t('portal.trainings.builder.stepper.settings.form.topicArea.label')
    "
    [placeholder]="
      t('portal.trainings.builder.stepper.settings.form.topicArea.placeholder')
    "
    [translocoPrefix]="'portal.trainings.builder.stepper.settings.form.topicArea.options'"
    [options]="dataService.topicAreas"
  />
  <app-select
    [control]="dataService.formGroupSettings.controls.duration"
    [label]="
      t('portal.trainings.builder.stepper.settings.form.phaseFrequency.label')
    "
    [placeholder]="
      t(
        'portal.trainings.builder.stepper.settings.form.phaseFrequency.placeholder'
      )
    "
    class="min-w-[180px]"
    [helpText]="
      t('portal.trainings.builder.stepper.settings.form.phaseFrequency.help')
    "
    [translocoPrefix]="'portal.trainings.builder.stepper.settings.form.phaseFrequency.options'"
    [options]="dataService.durationOptions"
  />
  <app-datepicker
    [control]="dataService.formGroupSettings.controls.startDate"
    [minDate]="dataService.minDate"
    [maxDate]="dataService.maxDate"
    [label]="
      t('portal.trainings.builder.stepper.settings.form.startDate.label')
    "
    [helpText]="
      t('portal.trainings.builder.stepper.settings.form.startDate.help')
    "
    [placeholder]="
      t('portal.trainings.builder.stepper.settings.form.startDate.placeholder')
    "
    [allowedMonths]="dataService.allowedMonths"
  />
  <app-select
    [control]="dataService.formGroupSettings.controls.notificationFrequency"
    [label]="
      t(
        'portal.trainings.builder.stepper.settings.form.notificationFrequency.label'
      )
    "
    [placeholder]="
      t(
        'portal.trainings.builder.stepper.settings.form.notificationFrequency.placeholder'
      )
    "
    class="min-w-[180px]"
    [helpText]="
      t(
        'portal.trainings.builder.stepper.settings.form.notificationFrequency.help'
      )
    "
    [translocoPrefix]="'portal.trainings.builder.stepper.settings.form.notificationFrequency.options'"
    [options]="optionsNotificationFrequency"
  />
</form>
